import { twMerge } from "tailwind-merge";

interface BadgeProps extends React.HTMLAttributes<HTMLSpanElement> {
  children: React.ReactNode;
  className?: string;
}

export function Badge({ children, className, ...props }: BadgeProps) {
  return (
    <span
      className={twMerge(
        "text-charcoal-500 rounded-full border border-slate-400 bg-white px-2 py-[1px] text-xs font-normal",
        className,
      )}
      {...props}
    >
      {children}
    </span>
  );
}
